import React from "react";

const LEVELS = [
  {
    id: 1,
    title: "Aware",
    subtitle: "Complete Baseline"
  },
  {
    id: 2,
    title: "Explorer",
    subtitle: "Build Habits"
  },
  {
    id: 3,
    title: "Adapter",
    subtitle: "Improve Performance"
  },
  {
    id: 4,
    title: "Thriver",
    subtitle: "Elite Vision"
  }
];

const JourneyTimeline = ({
  level = 1,
  journey
}) => {

  /* =====================================================
     CURRENT LEVEL
     Backend journey.currentLevel is given priority
  ===================================================== */

  const currentLevel =
    Number(
      journey?.currentLevel ??
      level ??
      1
    ) || 1;


  console.log(
    "Journey Timeline Current Level:",
    currentLevel
  );


  return (

    <div className="journey-timeline">

      {LEVELS.map((item, index) => {

        /* =================================================
           COMPLETED
           
           Example:
           currentLevel = 4

           Level 1 => true
           Level 2 => true
           Level 3 => true
           Level 4 => false
        ================================================= */

        const completed =
          currentLevel > item.id;


        /* =================================================
           ACTIVE

           Example:
           currentLevel = 4

           Level 4 => active
        ================================================= */

        const active =
          currentLevel === item.id;


        return (

          <React.Fragment
            key={item.id}
          >

            {/* =================================================
                LEVEL CARD
            ================================================= */}

            <div
              className={`
                timeline-step
                ${completed ? "completed" : ""}
                ${active ? "active" : ""}
              `}
            >

              {/* =================================================
                  CIRCLE
              ================================================= */}

              <div className="timeline-circle">

                {completed
                  ? "✓"
                  : item.id
                }

              </div>


              {/* =================================================
                  CONTENT
              ================================================= */}

              <div className="timeline-content">

                <h4>
                  {item.title}
                </h4>

                <p>
                  {item.subtitle}
                </p>

              </div>

            </div>


            {/* =================================================
                CONNECTING LINE
            ================================================= */}

            {index !== LEVELS.length - 1 && (

              <div
                className={`
                  timeline-line
                  ${
                    currentLevel > item.id
                      ? "completed"
                      : ""
                  }
                `}
              />

            )}

          </React.Fragment>

        );

      })}

    </div>

  );

};

export default JourneyTimeline;